import noop from "lodash/noop";
import React from "react";
import SearchByRut from "./SearchByRut";

export default function PatientSearch({ onSuccess, onError }) {
  return (
    <SearchByRut
      name="patientRun"
      label="Paciente"
      onSuccess={onSuccess}
      onError={onError || noop}
      type="patient"
    />
  );
}
